import React from 'react'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { Button, Stack, Typography, useTheme } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Validate } from '@e3dc-react/icons'
import { ApiPermissionType, ExtensionsType } from 'src/Libs/api/types'
import { useOwnerAccessRequest } from 'src/Libs/installation-rights-management/hooks'
import useModals from 'src/Hooks/useModals'
interface Props {
  item: AccountLinkModel
  withLabel?: boolean
}
const AccountLinkStatusIndicatorColumn: React.FC<Props> = ({ item, withLabel = true }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const { openInstallationAccessRightDialog } = useModals()
  const { accessRequests } = useOwnerAccessRequest(item.installationId)
  const isAccessBlocked = item?.permissionType === ApiPermissionType.blocked
  const isAccessPending = item?.permissionType === ApiPermissionType.pending

  const accessStatus = isAccessPending
    ? t('installation.access-and-invitations.table.columns.pending')
    : t('installation.access-and-invitations.table.columns.blocked')

  const handleAccessRight = (): void => {
    if (!accessRequests || !item) return

    const accessRequest = accessRequests.find(request => request.accountLinkId === item?.id)

    if (!accessRequest) return

    openInstallationAccessRightDialog({ installationId: item.installationId, accessRequest })
  }

  if (isAccessPending || isAccessBlocked) {
    return (
      <Stack direction="row" alignItems="center">
        <Typography variant="body2">{accessStatus}</Typography>
        <Button onClick={handleAccessRight} sx={{ marginLeft: theme.spacing(2) }}>
          {t('common.edit')}
        </Button>
      </Stack>
    )
  }

  if (item?.inviteId && item.permissionType !== ExtensionsType.luoxEnergy) {
    return (
      <Stack direction="row" alignItems="center">
        <Typography variant="body2">{t('installation.access-and-invitations.table.columns.invited')}</Typography>
        <Button sx={{ marginLeft: theme.spacing(2), minWidth: 'max-content' }}>
          {t('installation.access-and-invitations.table.columns.resend-cta')}
        </Button>
      </Stack>
    )
  }

  if ((item && !item.inviteId) || item?.permissionType === ExtensionsType.luoxEnergy) {
    return (
      <Stack direction="row" alignItems="center">
        <J2Validate />
        {withLabel && (
          <Typography variant="body2" sx={{ marginLeft: theme.spacing(2) }}>
            {t('installation.access-and-invitations.table.columns.approved')}
          </Typography>
        )}
      </Stack>
    )
  }
  return <Typography variant="body2">-</Typography>
}

export default AccountLinkStatusIndicatorColumn
